import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'
import SharedSections from './SharedSections'

const WebView = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <FieldLabel label='URL'>
      <Textfield
        placeholder='URL'
        name='url'
        value={content.url || ''}
        onChange={onChange('url')}
        disabled={disabled}
      />
    </FieldLabel>
  )
}

export default [{ label: 'WebView', content: WebView }, ...SharedSections]
